import { lazy } from 'react';

const ComplianceDashboard = lazy(() => import("../components/Compliance/ComplianceDashboard"));
const AdminDashboard = lazy(() => import("../components/Admin/AdminDashboard"));
const Profile = lazy(() => import("../components/Profile/Profile"));
const RiskDashboard = lazy(() => import("../components/Risk/RiskDashboard"));
const MovementAnalysisMap = lazy(() => import("../components/Behavior/MovementAnalysis"));
const BailDashboard = lazy(() => import("../components/Bail/BailDashboard"));
const BailSettings = lazy(() => import("../components/Bail/BailSettings"));
const PatternOfLifeTest = lazy(() => import("../pages/PatternOfLifeTest"));
//JT - 4/15/25 on permissions: For now using only 2 types until perms get more details.

export const AgentNavigationItems = [
  //{
  //  name: "Home",
  //  route: "/home",
  //  component: HomeDashboard
  //},
  {
    name: "Compliance",
    route: "/compliancedashboard",
    component: ComplianceDashboard,
  },
  {
    name: "Bail",
    route: "/baildashboard",
    component: BailDashboard,
    isBeta: true, // Flag to identify beta tabs
  },
  {
    name: "Analytics",
    route: "/pol-test",
    component: PatternOfLifeTest,
  },
  {
    name: "Profile", //Move later
    route: "/profiledashboard",
    component: Profile,
  },
  {
    name: "Risk", //Move later
    route: "/riskdashboard",
    component: RiskDashboard,
  },
  {
    name: "Behavior",
    route: "/behaviordashboard",
    component: MovementAnalysisMap,
  },
  {
    name: "Admin",
    route: "/admindashboard",
    component: AdminDashboard,
  }
];
